/**
 * useAccountTimezoneData — la liste des fuseaux (`GET api/timezones`), et seulement quand elle sert.
 *
 * Fuseau automatique, personne ne choisit : rien n'est demandé. La liste part quand le compte est
 * déjà en manuel à l'ouverture, ou au geste qui coupe l'automatique (`load`, que le crochet des
 * gestes appelle sans attendre la réponse de l'écriture). Une fois reçue, elle reste : rallumer
 * puis recouper l'automatique ne la redemande pas.
 */
import { useCallback, useEffect } from "react"
import { useSelector } from "react-redux"

import { authService } from "../../../../../../data/services/authService"
import { apiErrorMessage } from "../../../hooks/apiErrorMessage"
import { useApiFetch } from "../../../hooks/useApiFetch"
import { selectAuto } from "../../../../view-models/account/Timezone/accountTimezoneViewModel"

export const TIMEZONES_FAILED = "La liste des fuseaux n'a pas pu se charger."

export function useAccountTimezoneData() {
    const manual = !useSelector(selectAuto)

    const list = useApiFetch<unknown>({
        service: authService.getTimezones,
        requestKey: "timezones",
        fetchOnMount: false,
        skipWhilePending: true,
    })

    const { raw, fetch } = list
    const load = useCallback(() => {
        if (raw == null) fetch()
    }, [raw, fetch])

    useEffect(() => {
        if (manual) load()
        // Seulement quand le compte PASSE en manuel : `load` change d'identité avec la réponse.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [manual])

    return {
        raw,
        loading: list.loading,
        error: list.error != null ? apiErrorMessage(list.error, TIMEZONES_FAILED) : null,
        load,
        retry: fetch,
    }
}
